import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';

import { ContractInterface, GetContractUseCase, GetProfileUseCase, UserInterface } from '../../../core';
import { ErrorDialog } from '../../ui/dialog/error/error.dialog';
import { Loader } from '../../client/helpers/loader';

import { environment } from '../../../../environments/environment';

@Component({
    templateUrl: './contract.page.html',
    styleUrls: ['./contract.page.scss'],
})
export class ContractPage implements OnInit {
    public contract: ContractInterface;
    public user: UserInterface;
    public showBack = false;
    public showInfo = true;
    public back: Subject<boolean> = new Subject();
    public isClientPortal = environment.portalClient;

    constructor(
        private dialog: MatDialog,
        private getContractUseCase: GetContractUseCase,
        private getProfileUseCase: GetProfileUseCase,
        public loader: Loader
    ) {}

    ngOnInit() {
        this.getContract();

        if (!this.isClientPortal) {
            this.getProfile();
        }
    }

    private getContract() {
        this.getContractUseCase.bind().subscribe((transaction) => {
            if (transaction.isSuccess) {
                this.contract = transaction.data;
            } else if (!transaction.isAuthError) {
                this.dialog.open(ErrorDialog, {
                    data: { text: transaction.error },
                });
            }
        });
    }

    private getProfile() {
        this.getProfileUseCase.bind().subscribe((transaction) => {
            if (transaction.isSuccess) {
                this.user = transaction.data;
            } else if (!transaction.isAuthError) {
                this.dialog.open(ErrorDialog, {
                    data: { text: transaction.error },
                });
            }
        });
    }

    showBackButton() {
        this.showBack = true;
    }

    hideBackButton() {
        this.showBack = false;
    }

    showHeaderInfo() {
        this.showInfo = true;
    }

    hideHeaderInfo() {
        this.showInfo = false;
    }

    onBack() {
        this.back.next(true);
    }
}
